module.exports = __webpack_public_path__ + "img/logo.54f014b2.png";